// import React, { useEffect, useState } from 'react';
// import './AchievementTable.css';
// import axios from 'axios';
// import * as XLSX from 'xlsx'; // ✅ using only xlsx

// const AchievementTable = ({ pid, manager, startDate, endDate }) => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (!pid) return;

//     setLoading(true);

//     const params = new URLSearchParams({ pid });
//     if (manager) params.append("manager", manager);
//     if (startDate) params.append("startDate", startDate);
//     if (endDate) params.append("endDate", endDate);

//     axios
//       .get(`http://localhost:3006/api/team-view-achievement-table?${params}`)
//       .then(res => setData(res.data))
//       .catch(err => {
//         console.error("Failed to fetch achievements", err);
//         setData([]);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [pid, manager, startDate, endDate]);

//   const exportToExcel = () => {
//     const exportData = data.map(row => ({
//       "Organization PID": row.Organization_PID,
//       "Organization ID": row.Organization_Id,
//       "Employee Designation": row.Employee_Role,
//       "Employee Name": row.Employee_Name,
//       "Start Date": row.Start_Date,
//       "End Date": row.End_Date,
//       "DI + MSME": row.DI_MSME || 0,
//       "DFL": row.DFL || 0,
//       "YC": row.YC || 0,
//     }));

//     const worksheet = XLSX.utils.json_to_sheet(exportData);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Achievements");
//     XLSX.writeFile(workbook, "AchievementTable.xlsx"); // ✅ No file-saver used
//   };

//   if (!pid) return null;

//   return (
//     <div className="container">
//       <div className="table-wrapper">
//         <h2>Achievements</h2>

//         <button className="export-btn" onClick={exportToExcel}>Export to Excel</button>

//         {loading ? (
//           <p>Loading Data...</p>
//         ) : (
//           <table>
//             <thead>
//               <tr>
//                 <th rowSpan="2">PID</th>
//                 <th rowSpan="2">Org State</th>
//                 <th rowSpan="2">Emp Designation</th>
//                 <th rowSpan="2">Employee Name</th>
//                 <th rowSpan="2">Start Date</th>
//                 <th rowSpan="2">End Date</th>
//                 <th colSpan="3">Achievement (BR)</th>
//               </tr>
//               <tr>
//                 <th>DI + MSME</th>
//                 <th>DFL</th>
//                 <th>YC</th>
//               </tr>
//             </thead>
//             <tbody>
//               {data.map((row, index) => (
//                 <tr key={index}>
//                   <td>{row.Organization_PID}</td>
//                   <td>{row.state}</td>
//                   <td>{row.Employee_Role}</td>
//                   <td>{row.Employee_Name}</td>
//                   <td>{row.Start_Date}</td>
//                   <td>{row.End_Date}</td>
//                   <td>{row.DI_MSME || 0}</td>
//                   <td>{row.DFL || 0}</td>
//                   <td>{row.YC || 0}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AchievementTable;
import React, { useEffect, useState } from 'react';
import './AchievementTable.css';
import axios from 'axios';
import * as XLSX from 'xlsx';

const AchievementTable = ({ pid, manager, startDate, endDate }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!pid) return;

    setLoading(true);

    const params = new URLSearchParams({ pid });
    if (manager) params.append("manager", manager);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/team-view-achievement-table?${params}`)
      .then(res => setData(res.data))
      .catch(err => {
        console.error("Failed to fetch achievements", err);
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [pid, manager, startDate, endDate]);

  // Function to format date to DD-MM-YYYY
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Function to calculate total days between two dates
  const calculateTotalDays = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const diffTime = endDate - startDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays > 0 ? diffDays : 0;
  };
 
  const exportToExcel = () => {
    const exportData = data.map(row => ({
      "Organization PID": row.Organization_PID,
      "Organization State": row.state,
      "Employee Designation": row.Employee_Role,
      "Manager Name": row.Manager_Name,
      "Employee Name": row.Employee_Name,
      "Start Date": formatDate(row.Start_Date),
      "End Date": formatDate(row.End_Date),
      "Total Days": calculateTotalDays(row.Start_Date, row.End_Date),
      "DI + MSME": row.DI_MSME || 0,
      "DFL": row.DFL || 0,
      "YC": row.YC || 0,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Achievements");
    XLSX.writeFile(workbook, "AchievementTable.xlsx");
  };

  if (!pid) return null;

  return (
    <div className="container">
      <div className="table-wrapper">
        <h2>Achievements</h2>
        <button className="export-btn" onClick={exportToExcel}>Export to Excel</button>

        {loading ? (
          <p>Loading Data...</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th rowSpan="2">PID</th>
                <th rowSpan="2">Org State</th>
                <th rowSpan="2">Emp Designation</th>
                <th rowSpan="2">Manager Name</th>
                <th rowSpan="2">Employee Name</th>
                <th rowSpan="2">Start Date</th>
                <th rowSpan="2">End Date</th>
                <th rowSpan="2">Total Days</th>
                <th colSpan="3">Achievement (BR)</th>
              </tr>
              <tr>
                <th>DI + MSME</th>
                <th>DFL</th>
                <th>YC</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>{row.Organization_PID}</td>
                  <td>{row.state}</td>
                  <td>{row.Employee_Role}</td>
                  <td>{row.Manager_Name}</td>
                  <td>{row.Employee_Name}</td>
                  <td>{formatDate(row.Start_Date)}</td>
                  <td>{formatDate(row.End_Date)}</td>
                  <td>{calculateTotalDays(row.Start_Date, row.End_Date)}</td>
                  <td>{row.DI_MSME || 0}</td>
                  <td>{row.DFL || 0}</td>
                  <td>{row.YC || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AchievementTable;
